// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__b23o8","modalTitle":"Modal_modalTitle__12N8l"};